import React, { useEffect, useState } from 'react';
import { Accordion, Nav } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import dashboard_icon from '../assets/images/dashboard-icon.svg';
import file_icon from '../assets/images/file-icon.svg';
import profile_icon from '../assets/images/personal-info-icon.svg';
import vendor_icon from '../assets/images/vendors-left-icon.svg';
import {
  ALL_FILE_ROUTE,
  CGA_FILE_ROUTE,
  DASHBOARD_ROUTE,
  MY_FILE_ROUTE,
  PERSONAL_INFORMATION_ROUTE,
  VENDORS_ROUTE,
} from '../constants/RouteNameConstants';
import { resetDdashboardProofreader } from '../modules/authorization/Dashboard/actions';
import {
  resetEditorData,
  resetEditorDocumentData,
  resetVendorNextTranscript,
} from '../modules/authorization/Editor/actions';
import { resetProofreaderAllFiles } from '../modules/authorization/Files/AllFiles/actions';
import { getUserInfo } from '../utils/UserInfoUtils';

const Sidebar = ({
  setFullQcClick,
  setQcClick,
  setDueInDayClick,
  setDueInHalfDayClick,
  setLegalClick,
  activeKeyNew,
  handleFilterClear,
  handleVendorFilterClear,
  setDashboardClick,
}) => {
  const navigate = useNavigate();
  const userInfo = getUserInfo();
  const location = useLocation();
  const dispatch = useDispatch();
  const [localActiveKey, setLocalActiveKey] = useState(activeKeyNew);

  useEffect(() => {
    setLocalActiveKey(activeKeyNew);
  }, [activeKeyNew]);

  const getNavLinkStyles = (isActive) => ({
    background: isActive ? '#DFE3EE45' : undefined,
    color: isActive ? 'var(--sub-primary)' : undefined,
    fontWeight: isActive ? 500 : undefined,
  });

  const handleAccordionToggle = (eventKey) => {
    setLocalActiveKey(localActiveKey === eventKey ? null : eventKey);
  };

  return (
    <Nav className="sidebar custom-scroll">
      <Accordion activeKey={localActiveKey} className="accordion-sidebar">
        <style>
          {`
          .no-arrow .accordion-button::after {
            display: none !important;
          }
        `}
        </style>
        <Accordion.Item eventKey="0" className="no-arrow">
          <Accordion.Header
            onClick={() => {
              handleFilterClear();
              setFullQcClick(false);
              setQcClick(false);
              setDueInDayClick(false);
              setDueInHalfDayClick(false);
              setLegalClick(false);
              setDashboardClick(true);
              dispatch(resetDdashboardProofreader());
              dispatch(resetProofreaderAllFiles());
              dispatch(resetEditorData());
              dispatch(resetEditorDocumentData());
              dispatch(resetVendorNextTranscript());
              navigate(DASHBOARD_ROUTE);
            }}
            style={getNavLinkStyles(location.pathname === DASHBOARD_ROUTE)}
          >
            <img src={dashboard_icon} className="img-fluid" alt="metrics" />
            Dashboard
          </Accordion.Header>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header
            onClick={() => handleAccordionToggle('1')}
            style={getNavLinkStyles(location.pathname.includes('/files'))}
          >
            <img src={file_icon} className="img-fluid" alt="file" /> Files{' '}
          </Accordion.Header>
          <Accordion.Body>
            <div className="border-0 sidebarDropdown">
              <div
                className="acc-item-list"
                onClick={() => {
                  handleFilterClear();
                  setFullQcClick(false);
                  setQcClick(false);
                  setDueInDayClick(false);
                  setDueInHalfDayClick(false);
                  setLegalClick(false);
                  navigate(ALL_FILE_ROUTE);
                }}
                style={getNavLinkStyles(location.pathname === ALL_FILE_ROUTE)}
              >
                All Files
              </div>
              <div
                className="acc-item-list"
                onClick={() => {
                  handleFilterClear();
                  navigate(MY_FILE_ROUTE);
                }}
                style={getNavLinkStyles(location.pathname === MY_FILE_ROUTE)}
              >
                My Files
              </div>
              {userInfo?.UserRole === 'cgaproofreader' && <div
                className="acc-item-list"
                onClick={() => {
                  handleFilterClear();
                  navigate(CGA_FILE_ROUTE);
                }}
                style={getNavLinkStyles(location.pathname === CGA_FILE_ROUTE)}
              >
                CGA Files
              </div>}
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2" className="no-arrow">
          <Accordion.Header
            onClick={() => {
              handleAccordionToggle('2');
              handleVendorFilterClear();
              navigate(VENDORS_ROUTE);
            }}
            style={getNavLinkStyles(location.pathname === VENDORS_ROUTE)}
          >
            <img src={vendor_icon} className="img-fluid" alt="metrics" /> My Vendors
          </Accordion.Header>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header
            onClick={() => handleAccordionToggle('3')}
            style={getNavLinkStyles(location.pathname === PERSONAL_INFORMATION_ROUTE)}
          >
            <img src={profile_icon} className="img-fluid" alt="profile" /> Profile
          </Accordion.Header>
          <Accordion.Body>
            <div className="border-0 sidebarDropdown">
              <div
                className="acc-item-list"
                onClick={() => navigate(PERSONAL_INFORMATION_ROUTE)}
                style={getNavLinkStyles(location.pathname === PERSONAL_INFORMATION_ROUTE)}
              >
                Personal Information
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Nav>
  );
};

export default Sidebar;
